<eventq-dialog-popover
  [open]="open()"
  [title]="copy().title"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="copy().confirmLabel"
  [confirmDisabled]="submitDisabled()"
  placement="center"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="auto-process-popover__body">
    <div class="auto-process-popover__heading">
      <p>{{ copy().headingLines[0] }}</p>
      <p>{{ copy().headingLines[1] }}</p>
    </div>
    <div class="auto-process-popover__description">
      <p>{{ copy().bodyLines[0] }}</p>
      @if (copy().bodyLines[1]) {
        <p>{{ copy().bodyLines[1] }}</p>
      }
    </div>
  </div>
</eventq-dialog-popover>
